import { addModal } from 'weblite-web-modal-viewer'
import { CallType } from '@weblite/ts-action/media-proxy'
import { CallRoomIsFull } from './room-is-full'

const COMPONENT_ID = 'callRoomIsFull'

const showCallRoomIsFull = (props: Parameters<typeof CallRoomIsFull>[0]) =>
  addModal({ id: COMPONENT_ID, props })

export const showCallRoomIsFullDialog = (callType: CallType) =>
  showCallRoomIsFull({
    callType,
  })

export default {
  [COMPONENT_ID]: {
    Component: CallRoomIsFull,
  },
}
